const API_BASE_URL = process.env.NODE_ENV === 'production' 
  ? '/api'  // When deployed, uses Nginx proxy
  : 'http://41.186.188.115:5000/api';  // For local development

export default API_BASE_URL;